import * as React from 'react';

import { IAnalyticsData, IVillageBuilder } from '../../types';
import { PromotionItem } from '../CountrysidePromotionItem';
import { ICountrysidePromoItem, IPhoneSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import * as styles from './PromotionsBlock.css';

export interface IPromotionsBlockStoreProps {
  promotionsData: ICountrysidePromoItem[] | null;
  villageName: string | null;
  phone: IPhoneSchema | null;
  builder?: IVillageBuilder;
  analyticsData: IAnalyticsData;
  isEnabled: boolean;
}

export function PromotionsBlock({
  promotionsData,
  villageName,
  phone,
  analyticsData,
  isEnabled,
  builder,
}: IPromotionsBlockStoreProps) {
  if (!isEnabled || !promotionsData || promotionsData.length === 0) {
    return null;
  }

  return (
    <div className={styles['promotions-wrapper']} id="promotions">
      <div className={styles['container']}>
        <h2 className={styles['header']}>Акции в КП «{villageName}»</h2>
        <div className={styles['promotions-list']}>
          {promotionsData.map((item, index) => (
            <PromotionItem
              key={index}
              item={item}
              phone={phone}
              analyticsData={analyticsData}
              builder={builder}
              position={index + 1}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
